import { render, staticRenderFns } from "./b_SecurityEdit.vue?vue&type=template&id=4e10a36b&scoped=true&"
import script from "./b_SecurityEdit.vue?vue&type=script&lang=js&"
export * from "./b_SecurityEdit.vue?vue&type=script&lang=js&"
import style0 from "./b_SecurityEdit.vue?vue&type=style&index=0&id=4e10a36b&prod&lang=css&"
import style1 from "./b_SecurityEdit.vue?vue&type=style&index=1&id=4e10a36b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10a36b",
  null
  
)

export default component.exports